import React, { useState } from 'react';
import axios from 'axios';
import { Container, Form, Button, Row, Col, Pagination } from 'react-bootstrap';

const RealEstateSearch = ({listings, setListings, listingsCount, setListingsCount}) => {
  const [filters, setFilters] = useState({
    City: '',
    BedroomsTotal: '',
    BathroomsTotalInteger: '',
    PropertyType: '',
    YearBuilt: '',
    MlsStatus: '',
    CountyOrParish: ''
  });

  const [priceRange, setPriceRange] = useState([0, 1000000]);
  const [useGeo, setUseGeo] = useState(false);
  const [geo, setGeo] = useState({ lat: '', lon: '', distance: '10mi' });


  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 10;

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleGeoChange = (e) => {
    setGeo({ ...geo, [e.target.name]: e.target.value });
  };

  const handlePriceChange = (e, index) => {
    const newRange = [...priceRange];
    newRange[index] = parseInt(e.target.value);
    setPriceRange(newRange);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCurrentPage(1); // reset to first page on new search

    const payload = {
      filters: {
        ...Object.fromEntries(Object.entries(filters).filter(([_, v]) => v)),
        ...(priceRange[0] > 0 || priceRange[1] < 1000000
          ? {
              ListPrice: {
                ...(priceRange[0] > 0 && { min: priceRange[0] }),
                ...(priceRange[1] < 1000000 && { max: priceRange[1] })
              }
            }
          : {})
      },
      location:
        useGeo && geo.lat && geo.lon && geo.distance
          ? {
              lat: parseFloat(geo.lat),
              lon: parseFloat(geo.lon),
              distance: geo.distance
            }
          : undefined
    };

    try {
      const res = await axios.post('http://34.69.127.198:8000/search', payload);
      setListings(res.data.results);
      console.log(res.data.results);
      setListingsCount(res.data.results.length);
    } catch (err) {
      console.error(err);
    }
  };

  const paginatedResults = listings.slice(
    (currentPage - 1) * resultsPerPage,
    currentPage * resultsPerPage
  );

  const totalPages = Math.ceil(listingsCount / resultsPerPage);

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    return (
      <Pagination className="mt-3">
        <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
        {[...Array(totalPages)].map((_, idx) => {
          const page = idx + 1;
          return (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </Pagination.Item>
          );
        })}
        <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
    );
  };

  return (
    <Container>
      <h3 className="my-4">Real Estate Search</h3>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={3}><Form.Group><Form.Label>City</Form.Label><Form.Control name="City" value={filters.City} onChange={handleFilterChange} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>County</Form.Label><Form.Control name="CountyOrParish" value={filters.CountyOrParish} onChange={handleFilterChange} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>Status</Form.Label><Form.Control name="MlsStatus" value={filters.MlsStatus} onChange={handleFilterChange} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>Property Type</Form.Label><Form.Control name="PropertyType" value={filters.PropertyType} onChange={handleFilterChange} /></Form.Group></Col>
        </Row>

        <Row className="mt-3">
          <Col md={3}><Form.Group><Form.Label>Bedrooms</Form.Label><Form.Control type="number" name="BedroomsTotal" value={filters.BedroomsTotal} onChange={handleFilterChange} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>Bathrooms</Form.Label><Form.Control type="number" name="BathroomsTotalInteger" value={filters.BathroomsTotalInteger} onChange={handleFilterChange} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>Year Built</Form.Label><Form.Control type="number" name="YearBuilt" value={filters.YearBuilt} onChange={handleFilterChange} /></Form.Group></Col>
        </Row>

        <Row className="mt-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Price Range: ${priceRange[0].toLocaleString()} – ${priceRange[1].toLocaleString()}</Form.Label>
              <Form.Range
                min={0}
                max={1000000}
                step={5000}
                value={priceRange[0]}
                onChange={(e) => handlePriceChange(e, 0)}
              />
              <Form.Range
                min={0}
                max={1000000}
                step={5000}
                value={priceRange[1]}
                onChange={(e) => handlePriceChange(e, 1)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Check className="mt-4" type="switch" label="Enable location filter" checked={useGeo} onChange={() => setUseGeo(!useGeo)} />

        {useGeo && (
          <Row className="mt-2">
            <Col md={4}><Form.Control type="number" step="any" name="lat" placeholder="Latitude" value={geo.lat} onChange={handleGeoChange} /></Col>
            <Col md={4}><Form.Control type="number" step="any" name="lon" placeholder="Longitude" value={geo.lon} onChange={handleGeoChange} /></Col>
            <Col md={4}><Form.Control type="text" name="distance" placeholder="Distance (e.g., 10mi)" value={geo.distance} onChange={handleGeoChange} /></Col>
          </Row>
        )}

        <Button className="mt-4" type="submit">Search</Button>
      </Form>

      {listingsCount > 0 && (
        <div className="mt-4">
          <strong>{listingsCount}</strong> result{listingsCount !== 1 ? 's' : ''} found
        </div>
      )}


    </Container>
  );
};

export default RealEstateSearch;